export const DOCUMENTS_CACHE_TTL_MS = 60 * 1000;
export const DOCUMENTS_CACHE_MAX_ENTRIES = 50;

export const buildCacheKey = ({ retailerScope, source, customerId }) =>
  `${retailerScope}:${source}:${customerId || 'unknown'}`;

export const createDocumentsCacheStore = ({
  ttlMs = DOCUMENTS_CACHE_TTL_MS,
  maxEntries = DOCUMENTS_CACHE_MAX_ENTRIES
} = {}) => {
  const cache = new Map();

  const isFresh = (entry, now = Date.now()) => now - entry.cachedAt <= ttlMs;

  const trimToCapacity = () => {
    while (cache.size > maxEntries) {
      const oldestKey = cache.keys().next().value;
      cache.delete(oldestKey);
    }
  };

  return {
    getEntry(key) {
      const entry = cache.get(key);
      if (!entry) return null;

      if (!isFresh(entry)) {
        cache.delete(key);
        return null;
      }

      // Move key to the end to keep LRU order.
      cache.delete(key);
      cache.set(key, entry);
      return entry.documents || [];
    },

    setEntry(key, documents) {
      cache.delete(key);
      cache.set(key, { documents, cachedAt: Date.now() });
      trimToCapacity();
    },

    invalidate(key) {
      cache.delete(key);
    },

    invalidateAll() {
      cache.clear();
    }
  };
};

const documentsCacheStore = createDocumentsCacheStore();

export default documentsCacheStore;
